import { ChatPageWrapper } from "@mirage/mosaics/Chat/components/layouts/ChatPageLayout";
import { ComposeCurrentSessionContextProvider } from "@mirage/mosaics/ComposeAssistant/data/current-session/ComposeCurrentSessionContext";
import { memo } from "react";
import { WorkflowAgentPageContent } from "./WorkflowAgentPageContent";

import { AssistTemplatesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/AssistTemplatesContext";
import { ComposeAnalyticsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeAnalyticsContext";
import { ComposeSessionsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeSessionsContext";
import { ComposeVoicesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeVoicesContext";
export const WorkflowAgentPage = memo(() => {
  return (
    <ComposeSessionsContextProvider>
      <ComposeAnalyticsContextProvider>
        <ComposeVoicesContextProvider>
          <AssistTemplatesContextProvider>
            <ChatPageWrapper>
              <ComposeCurrentSessionContextProvider>
                <WorkflowAgentPageContent />
              </ComposeCurrentSessionContextProvider>
            </ChatPageWrapper>
          </AssistTemplatesContextProvider>
        </ComposeVoicesContextProvider>
      </ComposeAnalyticsContextProvider>
    </ComposeSessionsContextProvider>
  );
});

WorkflowAgentPage.displayName = "WorkflowAgentPage";
